import type { EmployeeProfileDto } from '@/modules/User/types/api/employee'

export function formatEmployeeFullName(
  profile: Pick<EmployeeProfileDto, 'firstName' | 'lastName'> | null | undefined
): string {
  if (!profile) {
    return ''
  }

  return `${profile.firstName} ${profile.lastName}`.trim()
}
